<template>
  <div class="wrapper">
    <div class="alph-filter">
      <div class="header">
        <Icon class="abcicon" :fill="'#fff'" :width="'22px'" :height="'22px'" :name="'abc'"/>
      </div>
      <div class="alphlist">
        <p :class="{active: !currentABC}" @click="selectABC('')">-</p>
        <p v-for="(abc, index) in alphabet" 
        :key="index" 
        :class="{active: currentABC === abc}"
        @click="selectABC(abc)">{{abc}}</p>
      </div>
    </div>
  </div>
</template>

<script>
import Icon from '@/components/Reusables/Icon'
export default {
  name: "AlphabetFilter",
  components:{
    Icon
  },
  data() {
    return {
      alphabet: [],
    };
  },
  // props:{
  //   show: {
  //     type: Boolean,
  //     default: false,
  //   }
  // },
  computed:{
    currentABC(){
      return this.$store.state.product.alphabet
    }
  },
  methods: {
    genABC() {
      let i = ('A').charCodeAt(0)
      let j = ('Z').charCodeAt(0)
      for(; i <= j; i++){
        this.alphabet.push(String.fromCharCode(i));
      }
    },
    selectABC(p){
        if(this.$route.name != 'home'){
            this.$router.push('/network')
        }
        // this.currentABC = p
        this.$store.commit('product/setABC', p);
    },
  },
  created() {
    this.genABC();
  }
};
</script>

<style scoped>
.alph-filter {
  width: 50px;
  height: 100vh;

  position: absolute;
  top: 0;
  right: 0;
  z-index: 4;
  transition: .3s ease-in-out;

  background:#C4CCCE;
}
.header{
  width: 100%;
  height: 50px;
  background: #353F43;
  position: relative;
}
.abcicon{
  position: absolute;
  top:50%;
  left:50%;
  transform: translate(-50%, -50%);
}
.alphlist{
  width: 100%;
  height: calc(100vh - 50px - env(safe-area-inset-bottom));
  overflow-y: auto;
}
p{
  line-height: 50px;
  text-align: center;
  font-size: 18px;
}
.active{
  background: #869193;
}
</style>


// WEBPACK FOOTER //
// src/components/AlphabetFilter.vue